import { Routes } from '@angular/router';

export const COOKIES_POLICY_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './pages/cookies-policy-index/cookies-policy-index.component'
          ).then((x) => x.CookiesPolicyIndexComponent),
      },
    ],
  },
];
